const COLOR_NETTO = "#0B2447"
const COLOR_SONSTIGE = "#1F78B4"
const COLOR_LUECKE = "#D62828"

const LABEL_NETTO = "Monatliches Nettoeinkommen"
const LABEL_SONSTIGE = "Bestehende sonstige Versorgung"
const LABEL_LUECKE = "Versorgungslücke"

const KTG_LABEL_MAP = {
    KTG_WOCHE_ERSTE: "1. Woche",
    KTG_WOCHE_ZWEITE: "2. Woche",
    KTG_WOCHE_DRITTE: "3. Woche",
    KTG_WOCHE_VIERTE: "4. Woche",
    KTG_WOCHE_FUENFTE: "5. Woche",
    KTG_WOCHE_SECHSTE: "6. Woche",
    KTG_WOCHE_SIEBTE: "7. Woche",
    KTG_WOCHE_VIERZEHNTE: "14. Woche",
    KTG_WOCHE_SIEBENUNDZWANZIGSTE: "27. Woche",
    KTG_WOCHE_VIERZIGSTE: "40. Woche",
    KTG_WOCHE_DREIUNDFUENFZIGSTE: "53. Woche",
    KTG_WOCHE_NEUNUNDSIEBZIGSTE: "79. Woche",
}

export const getWocheFromVsList = (list, woche) => list?.find(el => el?.art === woche)

const noNegative = (val) => Math.max(val, 0)

const buildLangfristigDataset = (data, target, key, label, color) => ({
    label,
    data: [
        noNegative(data?.ergebnisArbeitssicherungOhneErwerbsminderung?.[target]?.[key]) ?? null,
        noNegative(data?.ergebnisArbeitssicherungHalbeErwerbsminderung?.[target]?.[key]) ?? null,
        noNegative(data?.ergebnisArbeitssicherungOhneErwerbsminderung?.[target]?.[key]) ?? null,
    ],
    backgroundColor: color,
})

export const EinkommensschutzStreckeActions = ({
                                                   updateData,
                                                   getDataFromPointer,
                                                   getDataFromBackend,
                                               }) => {
    const buildKurzfristigTableData = (result, target) => {
        const targetWoche = getDataFromPointer("/einkommensschutz/kurzfristig/selectedArt") ?? "KTG_WOCHE_SIEBTE"
        const woche = getWocheFromVsList(result?.ergebnisKrankentagegeld?.[target]?.versorgungssituationList, targetWoche)

        const bruttoLabel = `Brutto ${KTG_LABEL_MAP[woche?.art]}`
        const nettoLabel = `Netto ${KTG_LABEL_MAP[woche?.art]}`

        updateData(woche, `/einkommensschutz/table/${target}/kurzfristig`)
        updateData(bruttoLabel, `/einkommensschutz/kurzfristig/${target}/headerBrutto`)
        updateData(nettoLabel, `/einkommensschutz/kurzfristig/${target}/headerNetto`)
    }

    const buildLangfristigChart = (snapshot, target) => {
        const chart = {
            bottomLabels: [
                "volle Erwerbsminderung",
                "halbe Erwerbsminderung",
                "Berufsunfähigkeit",
            ],
            datasets: [
                buildLangfristigDataset(snapshot, target, "nettoVersorgungAusEinkuenften", LABEL_NETTO, COLOR_NETTO),
                buildLangfristigDataset(snapshot, target, "bestehendeVersorgung", LABEL_SONSTIGE, COLOR_SONSTIGE),
                buildLangfristigDataset(snapshot, target, "luecke", LABEL_LUECKE, COLOR_LUECKE),
            ],
        }
        updateData(chart, `/einkommensschutz/charts/${target}/lang`)
    }

    const buildGesamtChartAndtables = (result, target) => {
        const ohneEM = result?.ergebnisArbeitssicherungOhneErwerbsminderung?.[target] ?? {}
        const halbeEM = result?.ergebnisArbeitssicherungHalbeErwerbsminderung?.[target] ?? {}
        const volleEM = result?.ergebnisArbeitssicherungVolleErwerbsminderung?.[target] ?? {}

        const ktgList = result?.ergebnisKrankentagegeld?.[target]?.versorgungssituationList
        const ktgWoche7 = getWocheFromVsList(ktgList, "KTG_WOCHE_SIEBTE") ?? {}
        const ziel = ohneEM?.ziel

        updateData(ohneEM, `/einkommensschutz/table/${target}/ohne`)
        updateData(halbeEM, `/einkommensschutz/table/${target}/halbe`)
        updateData(volleEM, `/einkommensschutz/table/${target}/volle`)
        updateData(ziel, `/einkommensschutz/${target}Nettoeinkommen`)

        const gesamtCharData = {
            bottomLabels: ["Nettogehalt", "Lohnfortzahlung", "", "Krankengeld", "", "volle Erwerbsminderung", "halbe Erwerbsminderung", "Berufsunfähigkeit"],
            datasets: [
                {
                    label: LABEL_NETTO,
                    data: [
                        ziel,
                        null,
                        null,
                        null,
                        null,
                        noNegative(volleEM.nettoVersorgungAusEinkuenften) ?? null,
                        noNegative(halbeEM.nettoVersorgungAusEinkuenften) ?? null,
                        noNegative(ohneEM.nettoVersorgungAusEinkuenften) ?? null,
                    ],
                    backgroundColor: COLOR_NETTO,
                },
                {
                    label: LABEL_SONSTIGE,
                    data: [
                        null,
                        noNegative(ziel),
                        null,
                        noNegative(ktgWoche7.bestehendeVersorgung) ?? null,
                        null,
                        noNegative(volleEM.bestehendeVersorgung) ?? null,
                        noNegative(halbeEM.bestehendeVersorgung) ?? null,
                        noNegative(ohneEM.bestehendeVersorgung) ?? null,
                    ],
                    backgroundColor: COLOR_SONSTIGE,
                },
                {
                    label: LABEL_LUECKE,
                    data: [
                        null,
                        null,
                        null,
                        noNegative(ktgWoche7.luecke) ?? null,
                        null,
                        noNegative(volleEM.luecke) ?? null,
                        noNegative(halbeEM.luecke) ?? null,
                        noNegative(ohneEM.luecke) ?? null,
                    ],
                    backgroundColor: COLOR_LUECKE,
                },
            ],
        }

        updateData(gesamtCharData, `/einkommensschutz/charts/${target}/gesamt`)
    }

    const buildKurzfristigChart = (result, target) => {
        const versorgungssituationList = result?.ergebnisKrankentagegeld?.[target]?.versorgungssituationList
        const chart = {
            bottomLabels: versorgungssituationList?.map((entry) => KTG_LABEL_MAP[entry.art] ?? entry.art),
            datasets: [
                {
                    label: LABEL_NETTO,
                    data: versorgungssituationList?.map((entry) => entry.nettoVersorgungAusEinkuenften ?? 0),
                    backgroundColor: COLOR_NETTO,
                },
                {
                    label: LABEL_SONSTIGE,
                    data: versorgungssituationList?.map((entry) => entry.bestehendeVersorgung ?? 0),
                    backgroundColor: COLOR_SONSTIGE,
                },
                {
                    label: LABEL_LUECKE,
                    data: versorgungssituationList?.map((entry) => entry.luecke ?? 0),
                    backgroundColor: COLOR_LUECKE,
                },
            ],
        }
        updateData(chart, `/einkommensschutz/charts/${target}/kurz`)
    }

    return {
        INIT_EINKOMMENSSCHUTZSTRECKE: async () => {
        },
        CALC_EINKOMMENSSCHUTZ: () => {
        },
        SELECT_KTG_ZEITPUNKT: () => {
            const result = getDataFromPointer("/einkommensschutz/result")
            buildKurzfristigTableData(result, "kunde")
        },
        SELECT_KTG_ZEITPUNKT_EHE: () => {
            const result = getDataFromPointer("/einkommensschutz/result")
            buildKurzfristigTableData(result, "ehepartner")
        },
        CALC_CONTEXTAREA_EINKOMMENSSCHUTZ: async (payload) => {
            let result
            if (payload?.calcData) {
                result = payload.calcData
            } else {
                const calcLink = payload?._links?.calculateEinkommenschutz
                if (!calcLink?.href) {
                    console.warn("[CALC_CONTEXTAREA_EINKOMMENSSCHUTZ] calculateEinkommenschutz-Link fehlt")
                    return
                }
                result = (await getDataFromBackend(calcLink))?._data ?? {}
            }

            buildKurzfristigTableData(result, "kunde")
            buildGesamtChartAndtables(result, "kunde")
            buildLangfristigChart(result, "kunde")
            buildKurzfristigChart(result, "kunde")

            buildKurzfristigTableData(result, "ehepartner")
            buildGesamtChartAndtables(result, "ehepartner")
            buildLangfristigChart(result, "ehepartner")
            buildKurzfristigChart(result, "ehepartner")

            const {
                ergebnisArbeitssicherungOhneErwerbsminderung,
                ergebnisArbeitssicherungHalbeErwerbsminderung,
                ergebnisArbeitssicherungVolleErwerbsminderung,
                ergebnisKrankentagegeld,
                ergebnisGehalt,
            } = result

            updateData(ergebnisArbeitssicherungOhneErwerbsminderung, "/ergebnisArbeitssicherungOhneErwerbsminderung")
            updateData(ergebnisArbeitssicherungHalbeErwerbsminderung, "/ergebnisArbeitssicherungHalbeErwerbsminderung")
            updateData(ergebnisArbeitssicherungVolleErwerbsminderung, "/ergebnisArbeitssicherungVolleErwerbsminderung")
            updateData(ergebnisKrankentagegeld, "/ergebnisKrankentagegeld")
            updateData(ergebnisGehalt, "/ergebnisGehalt")

            updateData(result, "/einkommensschutz/result")
        },
    }
}